import { useRef, useState, useEffect } from 'react';

function defaultTrigger(store, options) {
  const { disableHysteresis = false, threshold = 100, target } = options;
  const previous = store.current;

  if (target) {
    store.current =
      target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
  }

  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }

  return store.current > threshold;
}

export default function useScrollTrigger(options = {}) {
  const { getTrigger = defaultTrigger, target = window, ...other } = options;

  const store = useRef();
  const [trigger, setTrigger] = useState(() => getTrigger(store, other));

  useEffect(() => {
    const handleScroll = () => {
      setTrigger(getTrigger(store, { target, ...other }));
    };

    handleScroll();

    target.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      target.removeEventListener('scroll', handleScroll, { passive: true });
    };
  }, [target, getTrigger, JSON.stringify(other)]);

  return trigger;
}
